import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import route from 'ziggy-js';
import toastr from 'toastr'
import { usePage } from '@inertiajs/inertia-vue3'
import Inputmask from "inputmask/lib/inputmask";

window.swal = require('sweetalert2')
import mitt from 'mitt'
import {trim} from "lodash";

const emitter = mitt();

// Requiring the lodash library
const _ = require("lodash");

InertiaProgress.init();

// KTApp.init();
//
// // In-house components initialization
// KTMenu.createInstances();
// KTDrawer.createInstances();
// KTScroll.createInstances();
// KTScrolltop.createInstances();
// KTSticky.createInstances();
// KTDialer.createInstances();
// KTImageInput.createInstances();
// KTPasswordMeter.createInstances();
// KTSwapper.createInstances();
// KTToggle.createInstances();

createInertiaApp({
    id: "kt_body",
    resolve: function(name) {
        return require(`./Pages/${name}`);
    } ,
    setup({ el, App, props, plugin}) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin, toastr)
            .mixin({ methods: { route } });

        app.config.globalProperties.emitter = emitter;
        app.config.globalProperties._ = _;
        app.config.globalProperties.usePage = usePage();

        $.fn.select2.defaults.set("language", "pt-BR");

        app.directive('input-mask', {
            beforeMount: function(el) {
                Inputmask().mask(el);
            },

            updated: function(el) {
                Inputmask().mask(el);
            },
        });

        //Responsável por criar a diretiva v-select2 para ser usada em select2 para emitir os eventos de change
        app.directive('select2', {
            beforeMount: function (el, binding, vnode) {
                $(el).select2().on("select2:select", (e) => {
                    el.dispatchEvent(new Event('change', { target: e.target }));
                });
                $(el).select2().on("select2:unselect", (e) => {
                    el.dispatchEvent(new Event('change', { target: e.target }));
                });
            },
            updated: function(el) {
                $(el).trigger("change");
            }
        });

        app.mixin({
            methods: {
                can: function (permission) {
                    // if (permission.length === 0) {
                    //     return true
                    // }

                    let master = 'ADM';
                    let permissions = this.$page.props.permissions

                    if (permissions.includes(master)) {
                        return true;
                    }

                    if (Array.isArray(permission)) {
                        let hasPermission = false

                        permission.forEach(p => {
                            if (permissions.includes(trim(p))) {
                                hasPermission = true
                                return true
                            }
                        })

                        return hasPermission ?? false
                    }

                    return permissions.includes(trim(permission))
                },
                disposeTooltip() {
                    $('.tooltip').tooltip('dispose')
                }
            },
        })
        app.mount(el);
    },
});